import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import CheckerStatus from "./status/CheckerStatus";

const DeclinedRequests = () => {
  const userRole = useSelector(
    (state) => state?.userAuth?.data?.role
  )?.toLowerCase();
  return userRole === "checker" ? (
    <CheckerStatus
      status="declined"
      action={false}
      title="Declined Requests"
      search={true}
    />
  ) : (
    <Navigate to="/not-found" replace />
  );
};

export default DeclinedRequests;
